// ─── SINGLE SOURCE OF TRUTH ────────────────────────────────────────────────
// Payment links: Razorpay Dashboard → Payment Links/Pages → copy URL and paste below.
// Jab tak links empty hain, visitors ko booking form dikhega aur aapko email aa jayegi.
const site = {
  brand: "Sanvalio.",
  founder: "Deepankshi Saxena — Founder, Sanvalio & Design4You",
  tagline: "Strategy. Design. Growth.",

  payments: {
    // ₹999 growth call — Razorpay payment button (live)
    growthCall: { amount: 999, link: "", buttonId: "pl_Ta0bGLPkdk4VkM" },
  },

  schedule: {
    calendly: "https://deepankshi-saxena.dayschedule.com",
  },

  contact: {
    whatsapp: "918696938848",
    phone: "+918696938848",
    email: "support@sanvalio.com",
  },

  social: {
    linkedin: "https://www.linkedin.com/in/deepankshi-saxena/",
    instagram: "https://www.instagram.com/sanvalio/",
    facebook: "https://www.facebook.com/profile.php?id=61593807128453",
    instagramD4Y: "https://www.instagram.com/designn_4_you",
    facebookD4Y: "https://www.facebook.com/profile.php?id=61580865571957",
    sanvalio: "https://www.sanvalio.com",
    design4you: "https://www.design4you.co.in",
  },

  images: {
    portrait:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_brand-audit-hub-2/artifacts/1nsc3utx_WhatsApp%20Image%202026-09-03%20at%2014.26.00%20%281%29.jpeg",
    founderPoster:
      "https://design4you.co.in/founder.jpg",
    growthPoster:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_brand-audit-hub-2/artifacts/6qjtjyb3_09-build-with-intent%20%281%29.webp",
    brandPoster:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_brand-audit-hub-2/artifacts/4sj0ccdo_sanvalio-personal-brand-face-updated.webp",
    sanvalioWork:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_brand-audit-hub-2/artifacts/84chpll7_WhatsApp%20Image%202026-09-03%20at%2014.26.02%20%282%29.jpeg",
    sanvalioWork2:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_39f62d42-266b-412b-bc4a-e2b0a6d2d55d/artifacts/2jtjj7z5_ChatGPT%20Image%20Sep%207%2C%202026%2C%2006_10_28%20PM.png",
  },
};

export const waLink = (text = "Hi! I want to grow my brand.") =>
  site.contact.whatsapp
    ? `https://wa.me/${site.contact.whatsapp}?text=${encodeURIComponent(text)}`
    : "";

export default site;
